
import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {CountryLightModel, OrganizationOption, ResultError, ShipInfoModel, ShipsClient, ShipTypeLocalizedModel} from "@/api-client";
import ShipInfoModal from "@/features/documents/practices/components/ShipInfoModal.vue";
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";
import {debounceFn} from "debounce-decorator-ts";

@Component({
    components: {
        HeadingGroup,
        ShipInfoModal,
        ButtonWithConfirm
    }
})

export default class ShipInformation extends Vue {
    @Prop({default: () => ResultError.createEmpty()})
    validationErrors!: ResultError;
    
    @Prop({required: true})
    value!: ShipInfoModel;

    @Prop({required: true})
    countries!: CountryLightModel[];

    @Prop({required: true})
    typeOptions!: ShipTypeLocalizedModel[];

    @Prop({required: true})
    ownerOptions!: OrganizationOption[];

    @Prop({default: () => false})
    disableOwnerSelection!: boolean;
    
    @Prop({default: () => false})
    isInlandVessel!: boolean;
    
    @Prop({default: () => false})
    isPilotagePractice!: boolean;

    shipsFromSearch: ShipInfoModel[] = [];
    selectedShip: ShipInfoModel | null = null;
    shipToPassOnToModal: ShipInfoModel | null = null;
    activeShipSelectionInSearch: ShipInfoModel | null = null;
    searching = false;

    created() {
        this.$watch(
        () => this.value,
        () => {
            this.selectedShip = this.value;
            if (this.value == null) {
            this.activeShipSelectionInSearch = null;
            }
        },
        { immediate: true }
        );
        
    }

    onShipInfoChange(newShipInfo: ShipInfoModel | null) {
        this.$emit("input", newShipInfo);
        this.activeShipSelectionInSearch = null;
    }

    selectShip(ship: ShipInfoModel) {
        this.selectedShip = ship;
        this.onShipInfoChange(this.selectedShip);
        this.activeShipSelectionInSearch = ship; // Has to be after 'onShipInfoChange()'
    }

    async searchShips(searchTerm: string) {
        this.searching = true;
        await this.searchShipsDebounced(searchTerm);
    }

    @debounceFn(500, "searchShipsFn")
    async searchShipsDebounced(searchTerm: string) {
        if (searchTerm.trim() !== '') {
            this.shipsFromSearch = (await new ShipsClient().search(searchTerm));
            this.searching = false;
        } else {
            this.shipsFromSearch = [];
        }
    }

    get noResultText() {
        return this.searching ? this.$ls.Global_Placeholder_Searching : this.$ls.Documents_Practices_Search_Placeholder_NoShipsFound
    }

    getDescription(ship: ShipInfoModel) {
        return `${ship.name} ${ship.imoNr}`;
    }

    addNewShip() {
        this.shipToPassOnToModal = null;
        this.$bvModal.show('modal-ship-add')
    }

    editShipInfo() {
        this.shipToPassOnToModal = this.selectedShip;
        this.$bvModal.show('modal-ship-add')
    }
}
